import styled from '@emotion/styled';
import { Card, CardActionArea, CardContent as _CardContent, Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { useLocation } from 'react-use';

import { SPACING_REGULAR } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import AnchorTypography from '../../primitive/AnchorTypography';
import AspectRatioFixedImage from '../../primitive/AspectRatioFixedImage';

type Props = {
  url: string;
  title?: string | null;
  thumbnailImageUrl?: string;
  organizationId: string;
  className?: string;
};

const LatestInsightItem: FC<Props> = ({ url, title, thumbnailImageUrl, organizationId, className }) => {
  const location = useLocation();
  const _thumbnailImageUrl =
    thumbnailImageUrl != null && thumbnailImageUrl.trim() !== ''
      ? thumbnailImageUrl
      : '/assets/insight_thumbnail_default.png';

  const _url = new URL(url);
  if (_url.hostname === location.hostname) {
    _url.searchParams.append('org', organizationId);
  }

  return (
    <Root
      className={className}
      onClick={() => {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'latestInsightItemLinkClick', target_url: url });
        }
      }}
    >
      <AnchorLink href={_url.toString()} withNewTab>
        <ActionArea style={{ width: '100%' }}>
          <LatestInsightMedia src={_thumbnailImageUrl} aspectRatio={[3, 2]} backgroundSize="cover" />
          <CardContent>
            <LatestInsightTitle variant="subtitle1">{title}</LatestInsightTitle>
          </CardContent>
        </ActionArea>
      </AnchorLink>
    </Root>
  );
};

const Root = styled(Card)({
  height: '100%',
});

const AnchorLink = styled(AnchorTypography)({
  height: '100%',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },

  ...flexibleLayoutContainer({ direction: 'column', justifyContent: 'space-between' }),
});

const ActionArea = styled(CardActionArea)({
  color: '#ebebeb',
});

const CardContent = styled(_CardContent)({
  padding: SPACING_REGULAR,
});

const LatestInsightTitle = styled(Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  wordWrap: 'break-word',
  overflow: 'hidden',
  fontWeight: 500,
  marginBottom: 10,
});

const LatestInsightMedia = styled(AspectRatioFixedImage)({});

export default LatestInsightItem;
